import Vuelidate from 'vuelidate';
export function addVuelidatePlugin(Vue) {
    Vue.use(Vuelidate);
}
